import { FireCarousel } from '@nx/fire/carousel'

import styled from 'styled-components'

export const StyledFireCarousel = styled(FireCarousel)`
  margin-bottom: -13px;
  padding-bottom: 13px;
  margin-top: -13px;
  padding-top: 13px;
`
